export const IMAGES = {
  hero: "https://customer-assets-cm19k8pv.emergentagent.net/job_game-shot/artifacts/waufqc2i_VSC-41.webp",
};

export const PORTFOLIO = [
  {
    id: 1,
    title: "The Strike",
    tag: "Matchday",
    span: "md:col-span-7 md:row-span-2",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_game-shot/artifacts/wfgz7bha_8M3A8055.webp",
  },
  {
    id: 2,
    title: "Control",
    tag: "Matchday",
    span: "md:col-span-5",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_game-shot/artifacts/wd3ibkzq_8M3A0954.webp",
  },
  {
    id: 3,
    title: "Momentum",
    tag: "Motion",
    span: "md:col-span-5",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_game-shot/artifacts/k4xns4fg_GVFC-45.webp",
  },
  {
    id: 4,
    title: "The Duel",
    tag: "Emotion",
    span: "md:col-span-6",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_game-shot/artifacts/77lrgr96_8M3A7483.webp",
  },
  {
    id: 5,
    title: "Under Lights",
    tag: "Atmosphere",
    span: "md:col-span-6",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_game-shot/artifacts/waufqc2i_VSC-41.webp",
  },
  {
    id: 6,
    title: "Number Ten",
    tag: "Matchday",
    span: "md:col-span-4 md:row-span-2",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_game-shot/artifacts/wso0lcmm_VSC-23.webp",
  },
  {
    id: 7,
    title: "The Punch",
    tag: "Keepers",
    span: "md:col-span-4 md:row-span-2",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_game-shot/artifacts/1jb2kgxu_VSC-32.webp",
  },
  {
    id: 8,
    title: "Rising High",
    tag: "Motion",
    span: "md:col-span-4 md:row-span-2",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_game-shot/artifacts/7yzgnszo_8M3A6548.webp",
  },
  {
    id: 9,
    title: "The Squad",
    tag: "Team",
    span: "md:col-span-7",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_game-shot/artifacts/wgqlwzc1_GVFC-61.webp",
  },
  {
    id: 10,
    title: "Full Time",
    tag: "Emotion",
    span: "md:col-span-5",
    url: "https://customer-assets-cm19k8pv.emergentagent.net/job_game-shot/artifacts/9fcg2uhz_Lomarense-80.webp",
  },
];

export const CHAPTERS = [
  {
    num: "01",
    title: "I chase the split-second.",
    body: "TMB Fotografia lives on the touchline. Every frame is a decisive moment pulled from ninety minutes of chaos — the strike, the save, the roar. No staged poses. Only raw football.",
  },
  {
    num: "02",
    title: "Light is my teammate.",
    body: "Floodlights, low winter sun, the harsh noon glare. I read the stadium like a pitch and let the light carry the emotion. Grit over gloss. Atmosphere over perfection.",
  },
  {
    num: "03",
    title: "The story outlives the score.",
    body: "Scorelines fade. The photograph of a player on their knees, mud-streaked and electric, doesn't. I shoot for the memory that clubs, athletes and families keep forever.",
  },
];

export const SERVICES = [
  {
    title: "Matchday Coverage",
    desc: "Full 90-minute pitch-side coverage with same-night edited galleries. Perfect for clubs, leagues and press.",
  },
  {
    title: "Player Portraits",
    desc: "Cinematic, high-contrast portrait sessions built around your identity — on-pitch or studio, day or floodlight.",
  },
  {
    title: "Team & Club Branding",
    desc: "Squad photography, kit launches and social-ready content packages that make your club look elite.",
  },
  {
    title: "Print & Editorial",
    desc: "Fine-art prints and licensed editorial imagery for magazines, sponsors and stadium installations.",
  },
];
